import {
  ACRONYMS as ACRONYMS_CISA,
  GLOSSARY as GLOSSARY_CISA,
  FLASHCARDS as FLASHCARDS_CISA,
  QUESTIONS as QUESTIONS_CISA,
  ARTICLES as ARTICLES_CISA
} from  './cisa'

import {
  ACRONYMS as ACRONYMS_CISM,
  GLOSSARY as GLOSSARY_CISM,
  FLASHCARDS as FLASHCARDS_CISM,
  QUESTIONS as QUESTIONS_CISM,
  ARTICLES as ARTICLES_CISM
} from  './cism'

import {
  ACRONYMS as ACRONYMS_CRISC,
  GLOSSARY as GLOSSARY_CRISC,
  FLASHCARDS as FLASHCARDS_CRISC,
  QUESTIONS as QUESTIONS_CRISC,
  ARTICLES as ARTICLES_CRISC
} from  './crisc'

import {
  ACRONYMS as ACRONYMS_CDPSE,
  GLOSSARY as GLOSSARY_CDPSE,
  FLASHCARDS as FLASHCARDS_CDPSE,
  QUESTIONS as QUESTIONS_CDPSE,
  ARTICLES as ARTICLES_CDPSE
} from  './cdpse'

export const BUNDLE_ACRONYMS = {
  'cisa': ACRONYMS_CISA,
  'cism': ACRONYMS_CISM,
  'crisc': ACRONYMS_CRISC,
  'cdpse': ACRONYMS_CDPSE
}
export const BUNDLE_GLOSSARY = {
  'cisa': GLOSSARY_CISA,
  'cism': GLOSSARY_CISM,
  'crisc': GLOSSARY_CRISC,
  'cdpse': GLOSSARY_CDPSE
}
export const BUNDLE_FLASHCARDS = {
  'cisa': FLASHCARDS_CISA,
  'cism': FLASHCARDS_CISM,
  'crisc': FLASHCARDS_CRISC,
  'cdpse': FLASHCARDS_CDPSE
}
export const BUNDLE_QUESTIONS = {
  'cisa': QUESTIONS_CISA,
  'cism': QUESTIONS_CISM,
  'crisc': QUESTIONS_CRISC,
  'cdpse': QUESTIONS_CDPSE
}
// ISACA ships each cert as a single combined module (articles ride with questions, which
// stay eager), so articles can't be split into their own chunk here — LOAD_ARTICLES just
// returns the already-bundled data. Interface kept uniform with split-content brands.
const ARTICLE_DATA = {
  'cisa': ARTICLES_CISA,
  'cism': ARTICLES_CISM,
  'crisc': ARTICLES_CRISC,
  'cdpse': ARTICLES_CDPSE
}

export const LOAD_ARTICLES = async (cert) => ARTICLE_DATA[cert] || []

export const BUNDLE_ARTICLE_COUNTS = {
  'cisa': (ARTICLES_CISA || []).length,
  'cism': (ARTICLES_CISM || []).length,
  'crisc': (ARTICLES_CRISC || []).length,
  'cdpse': (ARTICLES_CDPSE || []).length
}

export const GET_TOTAL_QUESTIONS = (certificate) => {
  if (certificate == 'cisa') {
    return  QUESTIONS_CISA.length;
  }
  else if (certificate == 'cism') {
    return  QUESTIONS_CISM.length;
  }
  else if (certificate == 'crisc') {
    return  QUESTIONS_CRISC.length;
  }
  else if (certificate == 'cdpse') {
    return  QUESTIONS_CDPSE.length;
  }
  return QUESTIONS_CISA.length;
}
